import type { DeleteUserGroupsMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { DeleteUserGroupsDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

type DeleteUserGroupsInput = {
  UserGroupIds: string[];
};

export const useDeleteUserGroups = createMutationHook({
  name: 'deleteUserGroups',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.userGroup.delete.mutationOptions({ onSuccess }),
  mapInput: (variables: DeleteUserGroupsInput) => ({
    Ids: variables.UserGroupIds,
  }),
  invalidate: (trpc) => [
    trpc.frontend.userGroup.userGroupsWithApprovers.queryKey(),
    trpc.frontend.userGroup.userGroupById.queryKey(),
  ],
  mapResponse: (result: {
    deletedCount: number;
  }): DeleteUserGroupsMutation => ({
    deleteUserGroups: {
      __typename: 'GenericMutationOutput',
      affected_rows: result.deletedCount,
    },
  }),
  graphqlDocument: DeleteUserGroupsDocument,
  graphqlVariables: (variables: DeleteUserGroupsInput) => ({ ...variables }),
  evictFields: ['user_group', 'user_group_user'],
});
